import React, { useEffect, useState } from 'react';
import Button from '../../../components/button/Button';
import title from '../../../assets/webp-images/challenge-ob-number-title.png';
import PhoneInput from '../../../components/phoneInput/PhoneInput';
import { isMobileDevice } from '../../../utils/utils';
import { Mixpanel } from '../../../analytics/Mixpanel';

type Props = {
	onContinue: () => void;
	number: string;
	setNumber: (value: string) => void;
};

const ChallengeObNumber: React.FC<Props> = ({
	onContinue,
	number,
	setNumber,
}) => {
	const [isKeyboardOpen, setIsKeyboardOpen] = useState<boolean>(false);

	const handlePhoneChange = (value: string): void => {
		setNumber(value);
	};

	const onContinueTap = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Your number?',
			phone: number,
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
		onContinue();
	};

	useEffect(() => {
		if (!isKeyboardOpen && isMobileDevice()) {
			window.scrollTo(0, 0);
		}
	}, [isKeyboardOpen]);

	useEffect(() => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: 'Your number?',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
	}, []);

	return (
		<div style={{ display: 'flex', flexDirection: 'column', height: '70%' }}>
			<img src={title} style={{ width: '100%', marginTop: '16px' }} alt='' />
			<div
				style={{
					flex: '1',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '0 16px',
				}}>
				<PhoneInput
					onFocusHandle={() => setIsKeyboardOpen(true)}
					onBlurHandle={() => setIsKeyboardOpen(false)}
					defaultCountry='in'
					onPhoneChange={handlePhoneChange}
					phoneNumber={number}
					inputStyle={{
						marginTop: '10px',
					}}
					dropdownStyle={{}}
				/>
			</div>
			<Button
				isSticky={true}
				disabled={number.length < 10}
				style={{
					alignSelf: 'center',
					marginBottom: '24px',
					width: 'calc(100% - 56px)',
					background:
						number.length < 10
							? '#dddddd'
							: 'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
				}}
				onClick={onContinueTap}
				label={'Continue'}></Button>
		</div>
	);
};

export default ChallengeObNumber;
